// Tracks, per WorkHub tab, whether the pathway currently has an unresolved HV/organization
// uniqueness conflict. Published by Editor_Pathway (which sees the live editable) and read by
// the header's edit/view toggle, so the guard reflects unsaved edits — not just cached state.
// Kept per-tab (not a single global flag) so two open pathway tabs don't cross-block each other.
const conflictByTab = {};
export const setPathwayHVOrgConflict = (tabId, hasConflict) => {
    if (hasConflict)
        conflictByTab[tabId] = true;
    else
        delete conflictByTab[tabId];
};
export const hasPathwayHVOrgConflict = (tabId) => !!conflictByTab[tabId];
//# sourceMappingURL=hv-org-conflict-guard.js.map